module.exports = __webpack_public_path__ + "files/d37fe4e3fa1f2c4530f247749d350e87.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bold-webfont.eot
 ** module id = 430
 ** module chunks = 0
 **/